/**
 * Pure helper for CustomQuickAddDialog — computes the total sq ft from
 * the user-entered length/width and a unit (feet, inch, meter, cm, mm).
 *
 * Extracted into its own file so Jest can import it without pulling in
 * the shadcn Dialog (which uses the `@/lib/utils` alias that Jest's
 * default resolver doesn't understand).
 */
import { SIZE_UNIT_OPTIONS } from './constants';

export function calculateQuickAddSqFt(data) {
  const length = parseFloat(data.sizeLength) || 0;
  const width = parseFloat(data.sizeWidth) || 0;
  const unitOption = SIZE_UNIT_OPTIONS.find(u => u.value === data.sizeUnit);
  const toFeet = unitOption?.toFeet || 1;
  return length * width * toFeet * toFeet;
}
